<template>
  <div class="main">
    <!--<steps :dataList="dataList" :activeIndex="2"></steps>-->
    <div v-if="materialsPrice>0 || sysCenterId ==='00-77'" class="text-center assertive padding">所选项目，还需材料费{{materialsPrice}}元</div>
    <item title="体检者" :subhead="userInfo" :showIcon="false"></item>
    <item title="体检中心" class="centerName" :subhead="$store.state.center.sysCenter.name" :showIcon="false"></item>
    <m-input label="预约手机号" rules="/^1\d{2}\d{4}\d{4}$/" @suited="verifyMobile"
             v-model="mobilePhone" textAlign="right"
             placeholder="请输入预约手机号"></m-input>
    <item title="体检日期" :subhead="showTime" :subheadLight="dateTimeLight" class="margin-t-10"
          @itemClicked="openDatePicker"></item>

    <item title="专属服务" @itemClicked="showVIP" class="vip margin-t-10" v-show="vipProjectList.length"
          :subhead="vipName ||  (!isSelectVip ? '请选择' : '不需要')"></item>

    <item title="电子体检卡" @itemClicked="tapMedicalCardModel('show')"
          :class="{'useCard': medicalCardName}" v-if="available &&available.length"
          :subhead="medicalCardName || (available &&  available.length ? `有${available.length}张可用` : '无可用卡')"></item>
    <item title="电子体检卡" @itemClicked="tapMedicalCardModel('show')" class="margin-t-10 "
          v-else="!available || !available.length" subhead="无可用卡"></item>

    <div class="m-title"><i></i>支付方式</div>
    <div class="m-item" v-if="paymentMethodCodes && paymentMethodCodes['online'] && !hasVerify"
         :class="{'clear-borderBottom': $store.state.center.sysCenter.id ==='00-3' && coupon.price<=0 }"
         @click.stop="paymentClicked('online')">
      <span class="item-left" :class="{'assertive':payment==='online'}">
        <i class="icon" :class="payment==='online'?'assertive icon-radiobox':' icon-radiobox1'"></i>在线支付
      </span>
      <span class="item-right">
        <span class="m-sub" v-if="$store.state.sid==='00-30'">会员卡支付</span>
        <span class="m-sub" v-else>省去排队缴费的繁琐</span>
        <div class="discounts" v-if="coupon.price>0 && coupon.couponType == 2">满{{coupon.orderMinimum}}立减{{ coupon.price
          }}</div>
      </span>

    </div>
    <div class="m-item"
         v-if=" $store.state.center.sysCenter.id ==='00-3' &&  paymentMethodCodes && paymentMethodCodes['online'] && !hasVerify"
         @click.stop="paymentClicked('online')">
      <span class="item-right">
         <span class="light-label">随时退：支持全额退款&单个未检项目退款</span>
      </span>

    </div>
    <div class="m-item" :class="{'notEllipsis' : $store.state.center.sysCenter.id == '00-3' }"
         v-if="paymentMethodCodes&&paymentMethodCodes['onhospital'] || hasVerify"
         @click.stop="paymentClicked('onhospital')">
      <span class="item-left" :class="{'assertive':payment==='onhospital'}">
        <i class="icon " :class="payment==='onhospital'?'assertive icon-radiobox':' icon-radiobox1'"></i>去医院支付
      </span>
      <span class="item-right" v-show="$store.state.center.sysCenter.id !== '00-3'">
           <!--00-3-->
        <span
            class="m-sub">现付 {{$store.state.sid === '00-59' || $store.state.center.sysCenter.id === '00-59' ? '(禁体检卡)' : '(如体检卡等用户)'
          }}</span>
      </span>
      <span class="item-right" v-show="$store.state.center.sysCenter.id == '00-3'">
           <!--00-3-->
        <span
            class="m-sub">（仅支持现金，银行卡，体检卡用户）</span>
      </span>
    </div>
    <!--<div class="m-title"><i></i>预约服务</div>-->
    <!--<div class="" style="margin-top: 8px"></div>-->
    <item title="电子券" class="margin-t-10" @itemClicked="showCouponF" v-if="paymentMethodCodes && paymentMethodCodes['online'] && payment!=='onhospital'"
          :subhead="couponText"></item>

    <div class="margin-t-10">
      <!--<item title="健康基金" v-show="couponList.length && payment==='online'" @itemClicked="showCouponList = true"-->
      <!--:subhead="couponText"></item>-->

      <item title="医生审核" v-if="hasVerify"
            :subhead="'需要'"></item>
      <item title="电子报告" v-if="receiveOnlineFlag===1" @itemClicked="receiveOnlineShow=true"
            :subhead="receiveOnline.name"></item>

      <item title="纸质发票" v-show="payment==='online' && !hasVerify" @itemClicked="showDeliver"
            :subhead="deliver.name">
      </item>
      <div class="warning-info" v-if="sysCenterConfig.personalNotInvoiceNote && payment==='online' && !hasVerify">
        提示：{{ sysCenterConfig.personalNotInvoiceNote}}
      </div>
    </div>
    <div class="text-center assertive" v-if="sysCenterId === '00-76'">注：实际金额以到体检中心支付为准</div>
    <div class="m-foot">
      <div class="m-info">
        <p class="m-info-left">需支付：<span>￥<b>{{priceTotal}}</b></span></p>
      </div>
      <div class="m-next" :class="{'disabled':unSubmit}" @click.stop="submitOrder">提交订单</div>
    </div>

    <date-picker ref="datePicker" v-if="sysCenterId!=='00-7'" v-model="dateState" :dateList="dateList"
                 :fastingProjectList="fastingProjectList" :fastingCheckDate="fastingCheckDate"
                 @getTime="getTime"
                 @specialHandler="specialHandler"></date-picker>
    <date-picker-time v-else-if="sysCenterId==='00-7'" ref="datePickerTime" v-model="dateState" :dateList="dateList"
                      :dateTimeList="dateTimeList"
                      @getTime="getTime" @selectDate="selectDate"></date-picker-time>
    <van-actionsheet v-model="receiveOnlineShow" :actions="receiveOnlineList" cancel-text="取消"
                     @select="receiveOnlineSelect"></van-actionsheet>
    <!-- 不提供发票 -->

    <van-actionsheet v-model="showInvoice" :actions="[]" cancel-text="取消" :title="invoiceTitleText"></van-actionsheet>
    <van-actionsheet v-model="isDeliverShow" title="纸质发票(需个人承担邮寄费)">
      <div class="action-btn-group">
        <div class="action-btn" :class="{'assertive':deliverFlag===1}"
             @click.stop="deliverClicked(1)">需要
        </div>
        <div class="action-btn" :class="{'assertive':deliverFlag===0}"
             @click.stop="deliverClicked(0)">不需要
        </div>
      </div>
      <div v-if="deliverFlag===1">
        <div class="m-items">
          <span>抬头类型</span>
          <van-radio-group class="m-rads" v-model="data.invoiceTitleType">
            <van-radio class="m-rad" name="0">个人</van-radio>
            <van-radio class="m-rad" name="1">单位</van-radio>
          </van-radio-group>
        </div>
        <m-input label="发票抬头" rules="/^[\s\S]*.*[^\s][\s\S]*$/" @suited="verifyCompanyName"
                 v-model="data.companyName" placeholder="请输入发票抬头"></m-input>
        <m-input label="收件人" rules="/^[\s\S]*.*[^\s][\s\S]*$/" @suited="verifyConsignee"
                 v-model="data.consignee"
                 placeholder="请输入收件人"></m-input>
        <m-input label="联系电话" rules="/^1\d{2}\d{4}\d{4}$/" @suited="verifyLinkMobile"
                 v-model="data.mobile"
                 placeholder="请输入联系电话"></m-input>
        <m-input label="邮寄地址" rules="/^[\s\S]*.*[^\s][\s\S]*$/" @suited="verifyPostAddress"
                 v-model="data.postAddress"
                 placeholder="请输入邮寄地址"></m-input>
        <button class="btn" :class="{'disabled':!deliverValid}" @click.stop="deliverSubmit">确定</button>
      </div>
    </van-actionsheet>

    <van-actionsheet v-model="VIPModel" title="请确认是否提供专属服务" class="vipM">
      <div class="vip-content" v-for="(project,index) in vipProjectList" :class="{'active': project.select }"
           @click="selectTheVIP(project)">
        <div class="vip-price">
          <div><i class="icon" :class="{'icon-radiobox1': !project.select , 'icon-radiochecked': project.select}"></i>
          </div>
          {{project.item}}： {{project.price}}元
        </div>
        <div class="isShowInspection">
          <pre v-html="project.inspectionSignificance" :ref="'inspection' +  index "></pre>
          <button v-show='infoBtnIndexList.includes(index)' @click.stop="showDetails(project)">详情</button>
        </div>
      </div>
      <div class="action-btn-group">
        <div class="action-btn dark-btn" @click="selectTheVIP()">不需要
        </div>
      </div>
    </van-actionsheet>
    <vip-description :showModal="showProjectModal" :project="projectDetail"
                     @iconClicked="closeProjectDetail" @maskClicked="closeProjectDetail"></vip-description>
    <hint :showModal="hintShow" showTxt="请先确定您的体检日期,再进行专属服务的选择" :btnList="['取消','选择日期']" @btnClick="hintMsg"></hint>
    <hint :showModal="getMaterialsPriceCode" showTxt="<p class='text-center'>查询材料费失败，请稍后再试！</p>" :btnList="['返回上一页']"
          @btnClick="backPage"></hint>
    <hint :showModal="paymentModel" showTxt="选择去医院支付，将无法使用电子体检卡和电子券，请确认是否更改支付方式？" :btnList="['取消','确定']"
          @btnClick="paymentClickedHandler"></hint>
    <hint :showModal="notOnlinePaymentModel" showTxt="该中心未开通在线支付功能，请手动选择更改为医院支付！" :btnList="['我知道了！']"
          @btnClick="notOnlinePaymentClickedHandler"></hint>
    <hint :showModal="notCard" showTxt="该中心暂时只能使用医院支付，无法使用体检卡！" :btnList="['我知道了！']"
          @btnClick="notCardClickedHandler"></hint>
    <hint :showModal="verifyModelCode"
          :showTxt="`<div>尊敬的客户：</div> <p>您预约的是<span class='text-error'>今天(${dateTime})</span>的体检，医生来不及审核您的订单，请确认是否提交您的体检方案，直接进入体检环节</p>`"
          :btnList="['调整体检日期', '确认提交订单']"
          @btnClick="verifyDateClickedHandler"></hint>
    <hint :showModal="deleteProject" showTxt="是否确认放弃该项目的检查？" :btnList="['取消', '确定']"
          @btnClick="hintClick"></hint>
    <hint :showModal="showCouponProject" :showTxt="couponProjectText" :btnList="['取消', '确定']"
          @btnClick="couponProjectHandler"></hint>
    <hint :showModal="showCenterUser" showTxt="请先在医院挂号收费窗口办理实名就诊卡或官微注册电子就诊卡。" :btnList="['取消','确定']" @btnClick="hanlderUser"></hint>
    <van-popup v-model="showCouponList" class="couponList" position="bottom">
      <div class="isBox">
        <div class="certificateItem" v-for="(item,index) in couponList" @click="selectCoupon(item, index)"
             :key=" 'm1'+ item.id">
          <img :src="quan_01" alt="现金券" v-if="item.couponType === 1 || item.couponType === 2">
          <img :src="quan_04" alt="礼品券" v-if="item.couponType === 4">
          <img :src="quan_03" alt="项目券" v-if="item.couponType === 3">
          <div class="box row">
            <div class="box-left">
              <span v-if="item.couponType === 1">现金券</span>
              <span v-if="item.couponType === 2">满减券</span>
              <span v-if="item.couponType === 3">项目券</span>
              <span v-if="item.couponType === 4">礼品券</span>
            </div>
            <div class="box-content col">
              <div class="dark06 text-overflow">{{item.name}}</div>
              <div class="row">
                <span class="assertive col">面值：￥{{item.price}}</span>
                <span class="icon-danxuankuang icon col-auto" v-show="!item.select"></span>
                <span class="icon-radiochecked-copy icon col-auto" v-show="item.select"></span>
              </div>
              <div class="dark09 time row"><span>有效期：{{item.endDate}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="assertive text-center margin-t-10">不可用电子券</div>
        <div class="certificateItem" v-for="item in disabledCoupons"
             :key=" 'm'+ item.id">
          <img :src="quan_01" alt="现金券" v-if="item.couponType === 1 || item.couponType === 2">
          <img :src="quan_04" alt="礼品券" v-if="item.couponType === 4">
          <img :src="quan_03" alt="项目券" v-if="item.couponType === 3">
          <div class="box row">
            <div class="box-left">
              <span v-if="item.couponType === 1">现金券</span>
              <span v-if="item.couponType === 2">满减券</span>
              <span v-if="item.couponType === 3">项目券</span>
              <span v-if="item.couponType === 4">礼品券</span>
            </div>
            <div class="box-content col disabled-content">
              <div class="dark06 text-overflow">{{item.name}}</div>
              <div class="row">
                <span class="assertive col">面值：￥{{item.price}}</span>
                <span class="col-auto reason">{{item.reason}}</span>

              </div>
              <div class="dark09 time row"><span>有效期：{{item.endDate}}</span>
                <!--<span class="text-success text-right col" v-if="item.stateCode === '0'">未使用 </span>-->
                <!--<span class="assertive text-right col" v-if="item.stateCode === '1'">已使用 </span>-->
                <!--<span class="dark09 text-right col" v-if="item.stateCode === '2'">已过期 </span>-->
              </div>
            </div>
            <!--<div class="box-right">-->
            <!--<div class="btnUse use" v-if="item.stateCode === '0'">去使用 <i class="icon icon-arrow-right"></i></div>-->
            <!--<div class="btnUse" v-if="item.stateCode === '1'">已使用</div>-->
            <!--<div class="btnUse" v-if="item.stateCode === '2'">已过期</div>-->
            <!--</div>-->
          </div>

        </div>

      </div>
      <div class="isBottom row">
        <m-button class="col enableBtn" @click.native="couponChange(false)">返回</m-button>
        <m-button class="col" @click.native="couponChange(true)">使用电子券</m-button>
      </div>
    </van-popup>
    <van-popup v-model="medicalCardModel" class="medicalCardPopup" position="bottom">
      <div class="box">
        <div class="m-card" v-for="item in available">
          <card-item class="card-item">
            <div slot="item-left">
              <div>
                <img src="../../../public/images/vip.png" alt="">
              </div>
              <div>

              </div>
              <!--<div>{{item.cardNo}}</div>-->
            </div>
            <div slot="item-content">
              <div>可用余额</div>
              <div class="price"> ￥{{item.balance}}</div>
            </div>
            <div slot="item-right">
              <div>{{item.cardNo}}</div>
              <div @click="selectMedicalCard(item)"><i class="icon"
                                                       :class="{'icon-duoxuankuang': !item.select, 'icon-newxuanzhongduoxuan': item.select  }"></i>
              </div>
            </div>
          </card-item>
          <div class="lineMsg  flex-between">
            <div style="flex: 0 0 50%">{{ $store.state.center.sysCenter.name }}</div>
            <div>有效期： {{item.expiryDate}}</div>
          </div>
        </div>
        <div class="text-center text-error margin-t-10" v-if="disabled && disabled.length">不可用体检卡</div>
        <div class="m-card disabledCard" v-for="item in disabled">
          <card-item class="card-item">
            <div slot="item-left">
              <div>
                <img src="../../../public/images/vip.png" alt="">
              </div>
              <!--<div>-->

              <!--</div>-->
              <!--<div>{{item.cardNo}}</div>-->
            </div>
            <div slot="item-content">
              <div>可用余额</div>
              <div class="price"> ￥{{item.balance}}</div>
            </div>
            <div slot="item-right">
              <div>{{item.cardNo}}</div>
              <div class="">
                <button>{{item.stateName}}</button>
              </div>
            </div>
          </card-item>
          <div class="lineMsg  flex-between">
            <div style="flex: 0 0 50%">{{ $store.state.center.sysCenter.name }}</div>
            <div>有效期： {{item.expiryDate}}</div>
          </div>
        </div>

      </div>
      <div class="btns isBottom flex-between">
        <m-button type="default" class="enableBtn" @click.native="tapMedicalCardModel()">返回</m-button>
        <m-button type="default" class="enableBtn" @click.native="useMedicalCard()">使用体检卡</m-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import MButton from '../../components/common/button/m-button'
import MInput from '../../components/common/input/m-input'
import Steps from '@/components/common/steps/steps'
import Item from '@/components/common/item/item'
import CardItem from '@/components/common/item/index'
import DatePicker from '@/components/common/date/date-picker'
import { hint, vipDescription } from '@/components/common'
import DatePickerTime from '@/components/common/date/date-picker-time'
import { TEST_DATE_BY_PROJECT, COUPON_LIST, GET_LIMIT_NUM_FOR_DATE_007 } from '@/assets/scripts/api'
import { wxOAuth } from '@/assets/scripts/wechat'
import { mapGetters, mapState } from 'vuex'
import { Actionsheet, Tag, Toast, RadioGroup, Radio, CouponCell, CouponList } from 'vant'
import Vue from 'vue'
import quan_01 from '../../../public/images/quan_01.png'
import quan_04 from '../../../public/images/quan_04.png'
import quan_03 from '../../../public/images/quan_03.png'
import { Location, ToastMessage, Loading } from '@/assets/scripts/helper'
import Cookies from 'js-cookie'

Vue.use(Actionsheet).use(Tag).use(Toast).use(RadioGroup).use(Radio).use(CouponCell).use(CouponList)
export default {
  components: {Steps, Item, DatePicker, MInput, DatePickerTime, hint, vipDescription, CardItem, MButton},
  data () {
    return {
      quan_01,
      quan_03,
      quan_04,
      showCenterUser: false,
      deleteProject: false,
      nowDate: '',
      notCard: false,
      orderVerifyCode: false,
      verifyModelCode: false,
      notOnlinePaymentModel: false,
      medicalCardPrice: 0,
      //        actualPrice: 0,
      paymentModel: false,
      medicalCardName: '',
      available: [],
      disabled: [],
      medicalCardList: [],
      initMedicalCardList: [],
      medicalCardModel: false,
      showMedicalCard: false, //电子体检卡END
      getMaterialsPriceCode: false,
      showCouponList: false,
      isSelectVip: false,
      couponIndex: -1,
      couponText: '',
      couponList: [],
      disabledCoupons: [],
      showProjectModal: false,
      projectDetail: {},
      hintShow: false,
      dateList: [],
      dateTimeList: [],
      showCouponProject: false,
      couponProjectText: '',
      dataList: [
        {name: '确认项目'},
        {name: '确认日期'},
        {name: '预约成功'}
      ],
      data: {invoiceTitleType: '1'},
      payment: '',
      showIcon: false,
      affirmNo: '',
      dateTimeLight: true,
      deliverFlag: 0,
      showInvoice: false,
      invoiceBtn: [],
      invoiceTitleText: '',
      isDeliverShow: false,
      deliverList: [{name: '不需要', code: '0'}, {name: '需要', code: '1'}],
      deliver: {name: '不需要', code: '0'},
      receiveOnlineList: [{name: '需要（需在医院现场确认）', code: '1'}, {name: '不需要', code: '0'}],
      receiveOnline: {name: '不需要', code: '0'},
      receiveOnlineShow: false,
      dateState: false,
      affirmTime: '',
      arrCode: '', // 00-77
      materialsPrice: 0,
      showTime: '请选择体检日期',
      dateTime: '请选择体检日期',
      coupon: {price: 0},
      mobilePhoneValid: false,
      mobilePhone: '',
      deliverConsignee: '',
      deliverLinkMobile: '',
      deliverPostAddress: '',
      deliverCompanyName: '',
      submitLoading: false,
      VIPModel: false,
      initVipProjectList: [],
      vipPrice: 0,
      vipName: '',
      notUseCouponIndex: '',
      infoBtnIndexList: [],
      isdeletePro: {}
    }
  },
  watch: {
    dateTime (newV, oldV) {
      if (newV !== oldV && newV !== '请选择体检日期') {
        this.getVip()
      }
    },
    payment (newV, oldV) {
      if (newV !== oldV && newV && newV === 'online') {
        //          this.loadCouponData()
      }
    }
  },
  methods: {
    hanlderUser (index) {
      this.showCenterUser = false
      if (index) { Location('https://ali.whxh.com.cn/views/p187/index.html?auth=1&platformSource=1&platformId=187#/enrollment/enrollment') }
    },
    notCardClickedHandler () {
      this.notCard = false
    },
    notOnlinePaymentClickedHandler () {
      this.notOnlinePaymentModel = false
    },
    verifyDateClickedHandler (index) {
      this.verifyModelCode = false
      if (index === 1) {
        this.orderVerifyCode = true
        this.submitOrder()
      } else {
        this.openDatePicker()
      }
    },
    paymentClickedHandler (index) {
      if (index != 0) {
        this.available.forEach(obj => {
          obj.select = false
        })

        this.initMedicalCardList = []
        this.medicalCardList = []
        this.medicalCardPrice = 0
        this.medicalCardName = ''
        this.coupon = { price: 0}
        this.couponList.forEach(obj => {
          obj.select = false
        })
        this.couponIndex = ''
        this.couponText = ``
        this.payment = 'onhospital'
      }
      this.paymentModel = false
    },
    useMedicalCard () {
      this.medicalCardPrice = 0
      this.initMedicalCardList = JSON.parse(JSON.stringify(this.medicalCardList))
      this.medicalCardList.forEach(obj => {
        this.medicalCardPrice += obj.balance.toString().movePoint(2)
      })
      let medicalCardPrice = this.medicalCardPrice.toString().movePoint(-2)

      this.medicalCardName = this.initMedicalCardList.length ? `-${this.actualPrice > medicalCardPrice ? medicalCardPrice : this.actualPrice}元(${this.initMedicalCardList.length}张)` : ''

      if (this.medicalCardName) {
        //          this.couponIndex = -1
        //          this.coupon = {price: 0}
        //          this.couponText = ''

        this.$nextTick(() => {
          this.payment = 'online'
        })
      }
      this.medicalCardModel = false
    },
    tapMedicalCardModel (code) {
      if (this.hasVerify) {
        this.notCard = true
        return
      }
      if (code != 'show') { //返回
        this.medicalCardList = JSON.parse(JSON.stringify(this.initMedicalCardList))
      } else {
        this.available.forEach(obj => {
          if (this.medicalCardList.some(item => { return item.id === obj.id })) {
            obj.select = true
          }
        })
      }
      this.medicalCardModel = !this.medicalCardModel
    },
    couponChangeHandel (project) {
      let index = this.notUseCouponIndex
      let coupon = this.couponList[index]

      if ((coupon.couponType === 1 || coupon.couponType === 3) && coupon.exchangeProjectMap && coupon.exchangeProjectMap.id && project) {
        //          console.log(project.price , coupon.price , coupon.couponType === 1)
        coupon = Object.assign({}, coupon, {price: (project.price < coupon.price && coupon.couponType === 1) || coupon.couponType === 3 ? project.price : coupon.price })
        this.couponText = `${coupon.price}元(${coupon.exchangeProjectMap.item})`
      } else {
        this.couponText = `${coupon.price}元`
      }

      this.coupon = coupon
      this.couponIndex = index
      this.notUseCouponIndex = ''
      this.showCouponList = false
    },
    couponProjectHandler (index) {
      if (index == 1) {
        let coupon = this.couponList[this.notUseCouponIndex]
        let project = this.projectList.find(item => { return item.id === coupon.exchangeProjectMap.id })
        if (project) {
          this.$store.commit('project/checkProject', project)
          this.$store.commit('project/setProductProjects')
          this.$store.commit('project/setCheckedMaterialProjectList')
          this.couponChangeHandel(project)
        }
      }
      this.showCouponProject = false
    },
    selectCoupon (coupon, index) {
      //        console.log(coupon, index)
      if (!coupon.select) {
        this.couponList.forEach(obj => {
          obj.select = false
        })
      }
      coupon.select = !coupon.select
      this.notUseCouponIndex = coupon.select ? index : ''
    },
    showCouponF () {
      this.notUseCouponIndex = this.notUseCouponIndex === '' ? this.couponIndex : this.notUseCouponIndex
      this.showCouponList = true
    },
    couponChange (code) {
      if (!code) {
        this.couponList.forEach((obj, index) => {
          obj.select = (this.couponIndex === index)
        })
        this.notUseCouponIndex = ''
        this.showCouponList = false
      } else {
        if (this.notUseCouponIndex === '') {
          this.coupon = {
            price: 0
          }
          this.couponIndex = ''
          this.couponText = ''
          this.showCouponList = false
          return
        }
        // this.notUseCouponIndex   暂时保存，  每次确认后清除
        let coupon = this.couponList[this.notUseCouponIndex]
        if (coupon.couponType === 3 || (coupon.couponType === 1 && coupon.exchangeProjectMap && coupon.exchangeProjectMap.id)) {
          let project = this.projectList.find(item => { return item.id === coupon.exchangeProjectMap.id })
          if (!this.$store.state.project.checkedProjectList.some(obj => { return obj.id === coupon.exchangeProjectMap.id }) && (this.actualPrice.toString().movePoint(2) + project.price.toString().movePoint(2)).toString().movePoint(-2) > coupon.orderMinimum) {
            //             if(project.fastingCheck)
            this.couponProjectText = `当前所选体检项目中未包含此券优惠项目，使用此券将自动为您添加【${coupon.exchangeProjectMap.item}】体检项目， 请确认是否继续使用此券？`
            this.showCouponProject = true
          } else if (this.actualPrice > coupon.orderMinimum) { //已包含
            this.couponChangeHandel(project)
          }
        } else if (this.actualPrice > coupon.orderMinimum) { // 直接兑换
          this.couponChangeHandel()
        }
      }
    },
    showDetails (item) {
      this.projectDetail = item
      this.showProjectModal = true
    },
    closeProjectDetail () {
      this.showProjectModal = false
    },
    hintMsg (index) {
      this.hintShow = false
      if (index === 1) {
        this.openDatePicker()
      }
    },
    selectTheVIP (project) {
      this.isSelectVip = true
      if (project && project.canVip <= 0) {
        Toast.fail({
          duration: 3000,
          forbidClick: true,
          message: `您当前选择的体检日期，不提供  “${project.item}” 服务`
        })
        return
      }
      this.vipPrice = 0
      this.vipName = ''
      let projectIdList = []
      if (project) {
        projectIdList = this.getRelevanceProject(project)
        if (project.payment === 'online' || project.payment === 'batch') {
          this.payment = 'online'
        } else if (project.payment == 'onhospital') {
          this.payment = 'onhospital'
        }
      }
      this.vipProjectList.forEach(obj => {
        if (projectIdList.indexOf(obj.id) === -1) {
          obj.select = false
        } else {
          obj.select = true
          this.vipPrice = this.vipPrice + obj.price.toString().movePoint(2)
          this.vipName = (this.vipName ? `${this.vipName}+` : '') + `${obj.item}(${obj.price})`
        }
      })
      this.VIPModel = !this.VIPModel
    },
    getRelevanceProject (project) {
      let list = [project.id]
      if (project.relationships) {
        this.vipProjectList.forEach(obj => {
          if (project.relationships.split(',').indexOf(obj.id) !== -1 && obj.canVip > 0) {
            list.push(obj.id)
          }
        })
      }
      return list
    },
    async getMedicalCardList () {
      let params = {
        sysCenterId: this.sysCenterId,
        name: this.user.callName,
        idCardNo: ''
        //          name: '刘宇苹',
        //          idCardNo: "430723199309061463"
      }
      if (this.user.cardId && this.user.cardId.indexOf('*') === -1) {
        params.idCardNo = this.user.cardId
      } else if (this.user.idCardNo && this.user.idCardNo.indexOf('*') === -1) {
        params.idCardNo = this.user.idCardNo
      }
      if (this.product.id) {
        params.packageId = this.product.id
      }
      let {data} = await this.$axios.post('/center-service/exam_card/order_card', params)
      this.available = []
      data.available.forEach(obj => {
        obj.select = false
        this.available.push(obj)
      })
      this.disabled = data.disabled
    },
    selectMedicalCard (card) {
      let cardPrice = 0
      if (!card.select && this.medicalCardList.length >= 3) {
        Toast.fail('最多可选择三张电子体检卡')
      } else {
        this.medicalCardList.forEach(obj => {
          cardPrice += obj.balance.toString().movePoint(2)
        })
        cardPrice = cardPrice.toString().movePoint(-2)
        if (!card.select && this.medicalCardList.length < 3) {
          if (cardPrice < this.actualPrice) {
            card.select = true
            this.medicalCardList.push(card)
          } else {
            Toast.fail('所选体检卡金额已足够支付当前体检订单')
          }
        } else if (card.select) {
          card.select = false
          this.medicalCardList = this.medicalCardList.filter(obj => {
            return obj.id !== card.id
          })
        }
      }
    },
    async getVip () {
      let params = {
        _BIZCODE: '0001',
        sysCenterId: this.sysCenterId,
        boExaminationDate: this.dateTime,
        isDeliver: '',
        paymentType: '',
        packageId: '',
        age: this.user.age,
        sexCode: this.user.sexCode,
        price: this.priceInfo.priceTotal
      }
      let {data} = await this.$axios.post('/wx/2/appointment/valueAddedServiceItem.json', params)
      let projectList = []
      if (data.data && data.data.length) {
        projectList = data.data.filter(obj => { return this.priceTotal >= obj.minPrice && this.priceTotal <= obj.maxPrice && obj.isSupport === 1 && obj.limitNumber > 0 })
      }
      let arr = []
      this.projectList.forEach(project => {
        let j = projectList.find(obj => { return obj.projectId === project.id })
        if (j && !arr.some(obj => { return obj.projectId === project.id })) {
          arr.push(Object.assign({}, project, {select: false, payment: j.payment, canVip: j.canVip}))
        }
      })
      arr.sort((a, b) => { return a.price - b.price })
      this.initVipProjectList = arr
    },
    async showVIP () {
      if (this.dateTime === '请选择体检日期') {
        this.hintShow = true
        return
      }
      if (this.vipProjectList.length) {
        this.VIPModel = !this.VIPModel
        if (this.VIPModel) { this.infoBtnIndexList = [] }
        this.vipProjectList.forEach((obj, index) => {
          this.$nextTick(() => {
            var detailDom = this.$refs[`inspection${index}`]
            if (detailDom[0].clientHeight < detailDom[0].scrollHeight) {
              this.infoBtnIndexList.push(index)
            }
          })
        })
      } else {
        Toast.fail({
          duration: 2000,
          forbidClick: true,
          message: `专属服务暂不支持选择`
        })
      }
    },
    backPage () {
      this.$router.back()
    },
    showDeliver () {
      if (!this.sysCenterConfig.personalProvideInvoice) {
        this.showInvoice = true
        this.invoiceTitleText = this.sysCenterConfig.personalNotInvoiceNote
      } else {
        this.isDeliverShow = true
        if (this.deliver.code === '0') {
          this.deliverFlag = 0
        }
      }
    },
    deliverSubmit () {
      if (this.deliverValid) {
        this.deliver = this.deliverList[this.deliverFlag]
        this.isDeliverShow = false
      }
    },
    deliverClicked (index) {
      let item = this.deliverList[index]
      this.deliverFlag = index
      if (index === 0) {
        this.deliver = item
        this.isDeliverShow = false
      }
    },
    openDatePicker () {
      if (!(this.sysCenterId === '00-76' && this.$store.state.xyszOrderTime.date && this.product.id === this.$store.state.xyszOrderTime.productId)) {
        this.dateState = true
      }
    },
    verifyConsignee (result) {
      this.deliverConsignee = result
    },
    verifyCompanyName (result) {
      this.deliverCompanyName = result
    },
    verifyLinkMobile (result) {
      this.deliverLinkMobile = result
    },
    verifyPostAddress (result) {
      this.deliverPostAddress = result
    },
    verifyMobile (result) {
      this.mobilePhoneValid = result
    },
    paymentClicked (type) {
      if (type === 'onhospital' && ((this.medicalCardList && this.medicalCardList.length) || (this.coupon && this.coupon.price > 0))) {
        this.paymentModel = true
      } else { this.payment = type }
    },
    receiveOnlineSelect (item) {
      this.receiveOnline = item
      this.receiveOnlineShow = !this.receiveOnlineShow
    },
    async loadLimitNumForData007 (date) {
      Loading.show()
      let {data} = await this.$axios.get(GET_LIMIT_NUM_FOR_DATE_007, {
        params: {
          date: date
        }
      })
      Loading.close()
      return data
    },
    async loadCouponData (code) {
      let {data} = await this.$axios.get(COUPON_LIST, {
        params: {
          sysCenterId: this.sysCenterId,
          sexCode: this.user.sexCode,
          age: this.user.age,
          packageId: this.product.id || '',
          price: this.priceInfo.priceTotal,
          isDeliver: 0,
          payType: 'online',
          scope: 'exam'
        }
      })
      this.couponList = []

      this.disabledCoupons = []
      data.forEach((obj, index) => {
        obj.valueDesc = obj.price
        obj.unitDesc = '元'
        obj.condition = `满${obj.orderMinimum}元可用`
        obj.description = obj.content
        obj.startAt = new Date(obj.startDate).getTime() / 1000
        obj.endAt = new Date(obj.endDate).getTime() / 1000
        if (obj.available === 1) {
          this.couponList.push(Object.assign({}, obj, {select: false}))
        } else {
          this.disabledCoupons.push(obj)
        }
      })

      //        this.couponList.map((obj, index) => {
      //          if (this.coupon && obj.price > this.coupon.price && this.actualPrice > obj.orderMinimum && (!obj.exchangeProjectMap || !obj.exchangeProjectMap.id) && obj.couponType === 1) {
      //            this.couponIndex = index
      //            this.coupon = obj
      //            this.couponText = `${obj.price}元${obj.couponType === 2 ? ' (满立减)' : ''}`
      //            obj.select = true
      //          }
      //        })
      //        if (  this.couponText) {
      //          this.couponList.forEach((obj,index) => {
      //          if(index !== this.couponIndex ){
      //            obj.select = false
      //          }
      //          })
      //        }
    },
    async loadTestDate () {
      let proIds = this.$store.state.project.checkedProjectList.map((p) => {
        return p.id
      })

      //        let fastingProjectList = this.$store.state.project.checkedProjectList.filter(obj => { return obj.fastingCheck })
      //        fastingProjectList = fastingProjectList.map(obj => {
      //          obj.projectId = obj.id
      //          obj.projectName = obj.item
      //          return obj
      //        })
      if (this.product.id) {
        for (let packageProject of this.productProjects.packageProjectList) {
          if (!this.replacedProjects.includes(packageProject.id)) {
            proIds.push(packageProject.id)
          }
        }
      }

      let params = {
        sysCenterId: this.sysCenterId,
        proIds: proIds.join(',')
      }
      if (this.sysCenterId === '00-76' && this.$store.state.xyszOrderTime.date && this.product.id === this.$store.state.xyszOrderTime.productId) {
        this.showTime = `${this.$store.state.xyszOrderTime.date} (00:00-24:00)`
        this.dateTime = this.$store.state.xyszOrderTime.date
        this.affirmTime = '00:00-24:00'
      } else if (this.sysCenterId === '00-77') {
        //        this.getMaterialsPrice(params)
        let {data} = await this.$axios.get('/order/getAppointmentRangeForNansan.json', {params: params})
        this.dateList = data
        this.dateList.forEach(obj => {
          obj.testTimes.forEach(item => {
            item.no = item.no + ',' + item.arrCode
          })
        })
      } else if (this.sysCenterId === '00-7') {
        let {data} = await this.$axios.get('/order/getAppointmentRange.json', {params: params})
        this.dateList = data
      } else {
        let {data} = await this.$axios.get(TEST_DATE_BY_PROJECT, {params: params})
        let $this = this
        this.dateList = data.map(date => {
          date.specialProDtos = date.specialProDtos.map(specialProject => {
            let project = $this.$store.state.project.checkedProjectList.find(p => p.id === specialProject.projectId)
            if (project) {
              specialProject.base = project.base
              specialProject.delectable = project.delectable
            }
            if (specialProject.delectable === '0') {
              date.code = specialProject.code
            }
            return specialProject
          })
          return date
        })
      }
    },
    async selectDate (date) {
      let dateInfo = await this.loadLimitNumForData007(date.replace(/-/g, ''))
      this.dateTimeList = dateInfo.dateHasPeopleList || []
    },
    getTime (data) {
      this.showTime = `${data.date} (${data.time})`
      this.dateTime = data.date
      this.affirmTime = data.time
      if (this.sysCenterId === '00-77') {
        this.affirmNo = data.id ? data.id.split(',')[0] : ''
        this.arrCode = data.id ? data.id.split(',')[1] : ''
      } else {
        this.affirmNo = data.id || ''
      }
    },
    specialHandler (date, specialProject) {
      this.deleteProject = true
      this.isdeletePro = {
        date, specialProject
      }
    },
    async deletePro () {
      let {date, specialProject} = this.isdeletePro
      Loading.show()
      await this.$store.commit('project/checkProject', this.$store.state.project.checkedProjectList.find(p => p.id === specialProject.projectId))
      await this.loadTestDate()
      Loading.close()
    },
    hintClick (index) {
      //         if()
      if (index) {
        this.deletePro()
      }
      this.deleteProject = false
    },
    ergodicArr (num, id) {
      let arr = []
      for (let i = 0; i < num; i++) {
        arr.push(id)
      }
      return arr
    },
    async submitOrder () {
      if (this.submitLoading) {
        return
      }
      if (!this.payment) {
        ToastMessage('请选择支付方式')
      } else if (!this.mobilePhoneValid) {
        ToastMessage('请填写正确的手机号')
      } else if (this.dateTime === '请选择体检日期') {
        ToastMessage('请选择体检日期')
      } else if (!this.isSelectVip && this.payment === 'online' && this.vipProjectList && this.vipProjectList.length) {
        //        this.isSelectVip  =  true
        this.VIPModel = true
      } else if (this.medicalCardList && this.medicalCardList.length && (!this.paymentMethodCodes['online'] || this.hasVerify) && this.priceTotal > 0) {
        this.notOnlinePaymentModel = true
      } else if (this.nowDate === new Date(this.dateTime).getTime() && !this.orderVerifyCode && this.hasVerify) {
        this.verifyModelCode = true
      } else {
        //          if (this.sysCenterId === '00-05') {
        //            let {data} = await this.$axios.get('/hospital/checkrealname', {
        //              params: {
        //                zjlx: '01',
        //                pat_name:  this.user.name || this.user.callName,
        //                zjhm: this.user.cardId || this.user.idCardNo
        //              }
        //            })
        //            if (data.code === -1) {
        //              this.showCenterUser = true
        //              return
        //            }
        //          }
        let order = {
          'sysCenterId': this.sysCenterId,
          'sysCenterName': this.$store.state.center.sysCenter.name,
          'name': this.user.name || this.user.callName,
          'callName': this.user.name || this.user.callName,
          'marryStateCode': this.user.marryStateCode,
          'marryState': this.marryStateName,
          'age': this.user.age,
          'sexCode': this.user.sexCode,
          'sexName': this.sexName,
          'boCellPhoneNo': this.mobilePhone,
          'identityCardNo': this.user.cardId || this.user.idCardNo,
          'instanceId': this.$route.query.instanceId,
          'customIdList': [],
          'recommendIdList': [],
          'materialList': [],
          'price': this.priceTotal,
          'discountPriceTotal': this.priceTotal,
          'autoBind': this.receiveOnline.code,
          'invoiceTitleType': '0',
          'boExaminationDate': this.dateTime,
          'boExaminationTime': this.affirmTime,
          'boExaminationTimeNo': this.affirmNo,
          'payType': this.payment,
          'paymentType': this.payment,
          'scope': this.scope,
          'coupon': this.payment !== 'online' ? '' : this.coupon.id,
          'isDeliver': '0',
          '_BIZCODE': '0002',
          'packages': [],
          'isPackage': ''
        }
        if (this.scope === 'package' && this.$store.state.project.checkedProjectList.length === 0) {
          order.isPackage = '1'
        }

        if (this.$store.state.quickAppointment) {
          order._BIZCODE = '0019'
          order.id = this.$store.state.quickAppointment
        }
        if (this.medicalCardList && this.medicalCardList.length) {
          order.cardNoList = []
          this.medicalCardList.forEach(obj => {
            order.cardNoList.push(obj.cardNo)
          })
        }
        if (this.sysCenterId === '00-77') {
          order.boExaminationTimeId = this.arrCode
          if (this.materialsPrice) {
            order.customIdList.push('284eb903-f659-4848-9c06-70017370073f')
            order.customMaterial = {
              'id': '284eb903-f659-4848-9c06-70017370073f',
              'price': this.materialsPrice
            }
          }
        }
        if (this.schemeClass && this.schemeClass.grade) {
          order.grade = this.schemeClass.grade
          order.gradeName = this.schemeClass.gradeName
          if (this.schemeClass.projectIdList && this.schemeClass.projectIdList.length) order.schemeDeleted = this.schemeClass
        }
        if (this.deliver.code === '1') {
          Object.assign(order, this.data)
        }
        let num
        for (let materialProject of this.$store.state.project.checkedMaterialProjectList) {
          if (materialProject.recalculate === 0) {
            num = materialProject.count > 0 ? 1 : 0
          } else {
            num = materialProject.count
          }
          if (num > 0) {
            let arr = await this.ergodicArr(num, materialProject.id)
            order.customIdList = order.customIdList.concat(arr)
          }
        }

        for (let project of this.$store.state.project.checkedProjectList) {
          if (project.base !== 1 && project.packable !== 1 && project.recommendable !== 1) {
            order.customIdList.push(project.id)
          } else {
            order.recommendIdList.push(project.id)
          }
        }
        if (this.product.id) {
          order.testPackageId = this.product.id
        }
        if (this.$route.query.instanceId === 'pd') {
          let materialList = []
          order.instanceId = this.$store.state.project.instanceId
          if (this.parckagemTransformList.some(obj => { return obj.reduce > 0 }) || (this.productProjects.packageProjectList && this.productProjects.packageProjectList.length)) { //或者无转换关系的关联项目
            this.parckagemTransformList.forEach(async obj => {
              let customIdListArr = await this.ergodicArr(obj.num, obj.id)
              if (order.packages.indexOf(obj.parentId) === -1) {
                order.packages.push(obj.parentId)
              }
              order.customIdList = order.customIdList.concat(customIdListArr)
            })
          }
          this.productProjects.replaced.projectList.forEach(obj => {
            order.packages.push(obj.id)
          })
        }
        let message
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '正在提交'
        })
        if (window.location.search.indexOf('custom') !== -1) {
          delete order.instanceId
        }

        if (this.vipPrice) {
          this.vipProjectList.forEach(obj => {
            if (obj.select) order.customIdList.push(obj.id)
          })
        }
        let {data} = await this.$axios.post('/wx/2/appointment/order.json', order)
        this.submitLoading = true
        if (this.$store.state.quickAppointment) {
          let pay = 'notPay'
          if (this.payment === 'online' && this.priceTotal > 0) pay = 'pay'
          this.$router.replace({
            name: 'personalOrder',
            params: {sysCenterId: order.sysCenterId, id: data.orderId},
            query: {type: 1, code: pay}
          })
          return
        }
        if (data.data.code === '-1') {
          message = '您未支付的订单已超过3个'
        } else if (data.data.code === '-2') {
          message = '您已有未支付/未完成的体检订单'
        } else if (data.data.code === '-3') {
          message = this.dateTime + '预约已满，请选择其他日期'
        } else {
          Toast.clear()
          if (this.payment === 'online' && this.priceTotal > 0) {
            let payData = {}
            payData.sysCenterName = order.sysCenterName
            payData.date = order.boExaminationDate
            payData.sysCenterId = order.sysCenterId
            payData.price = parseFloat(this.priceTotal.toString().movePointRight(2)) + parseFloat((this.payment === 'online' && this.coupon.price ? this.coupon.price : 0).toString().movePointRight(2)) //订单金额
            payData.couponPrice = parseFloat((this.coupon.price + '')) //折扣
            payData.coupon = this.coupon.id //折扣
            payData.deliverPrice = 0
            payData.img = this.$store.state.imageResourcesUrl + '/img/custom-pic.png'
            payData.name = '个体化体检方案'
            payData.orderId = data.data.orderId
            payData.orderNo = data.data.orderNo
            payData.groupcheck = '0'
            Location(wxOAuth(this.$store.state.wxContentUrl + `/pay.html?sid=${Cookies.get('51jk._initSid')}&versions=old&showwxpaytitle=1&pay=` + encodeURIComponent(JSON.stringify(payData))), true)
          } else if (this.hasVerify && this.nowDate !== new Date(this.dateTime).getTime()) {
            this.$router.replace({
              name: 'orderVerify',
              query: {
                sysCenterName: order.sysCenterName,
                sysCenterId: order.sysCenterId,
                orderNo: data.data.orderNo,
                orderId: data.data.orderId,
                datetime: order.boExaminationDate
              }
            })
          } else {
            this.$router.replace({
              name: 'orderSucceed',
              query: {
                sysCenterName: order.sysCenterName,
                sysCenterId: order.sysCenterId,
                orderNo: data.data.orderNo,
                orderId: data.data.orderId,
                datetime: order.boExaminationDate
              }
            })
          }
          return
        }
        Toast.clear()
        ToastMessage(message)
        this.submitLoading = false
      }
    },
    async getMaterialsPrice () {
      let proIds = this.$store.state.project.checkedProjectList.map((p) => {
        return p.id
      })
      if (this.product.id) {
        for (let packageProject of this.productProjects.packageProjectList) {
          if (!this.replacedProjects.includes(packageProject.id)) {
            proIds.push(packageProject.id)
          }
        }
      }

      let {data} = await this.$axios.get('/order/getOrderMaterialsFee.json', {params: {'combCodes': proIds.join(';')}})
      if (!data.success) {
        this.getMaterialsPriceCode = true
      } else { this.materialsPrice = parseFloat(data.returnData.price) }
    }
  },
  computed: {
    fastingCheckDate () {
      let fastingCheck = {
        startHour: '',
        startMinute: '',
        endHour: '',
        endMinute: ''
      }
      if (!((!this.sysCenterConfig.fastingCheckStart || this.sysCenterConfig.fastingCheckStart === '00:00') && (!this.sysCenterConfig.fastingCheckEnd || this.sysCenterConfig.fastingCheckEnd === '24:00'))) {
        //         console.log(this.sysCenterConfig.fastingCheckStart.split(':')[0])
        let fastingCheckStart = this.sysCenterConfig.fastingCheckStart.split(':')
        let fastingCheckEnd = this.sysCenterConfig.fastingCheckEnd.split(':')
        fastingCheck.startHour = parseInt(fastingCheckStart[0])
        fastingCheck.startMinute = parseInt(fastingCheckStart[1])
        fastingCheck.endHour = parseInt(fastingCheckEnd[0])
        fastingCheck.endMinute = parseInt(fastingCheckEnd[1])
      }
      return fastingCheck
    },
    fastingProjectList () {
      let fastingProjectList = this.$store.state.project.checkedProjectList.filter(obj => { return obj.fastingCheck })
      if (fastingProjectList && fastingProjectList.length) {
        fastingProjectList = fastingProjectList.map(obj => {
          obj.projectId = obj.id
          obj.projectName = obj.item
          return obj
        })
      }
      return fastingProjectList || []
    },
    ...mapGetters({
      replacedProjects: 'project/getReplacedProjects',
      priceInfo: 'project/priceInfo',
      baseProjectList: 'project/getBaseProjectList',
      projectListList: 'project/getCustomProjectList',
      materialProjectList: 'project/getMaterialProjectList'
    }),
    ...mapState('project', {
      schemeClass: state => state.schemeClass,
      productProjects: state => state.productProjects,
      mTransformList: state => state.mTransformList,
      productMaterialProjectList: state => state.productMaterialProjectList,
      projectList: state => state.projectList,
      product: state => state.product
    }),
    ...mapState('center', {
      sysCenterConfig: state => state.sysCenter

    }),
    parckagemTransformList () {
      let list = []
      let materialList = []
      if (this.mTransformList && this.mTransformList.tree) {
        list = JSON.parse(JSON.stringify(this.mTransformList.tree))
        list.forEach(obj => {
          obj.childernList.forEach((item, index) => {
            if (this.productMaterialProjectList[item.id] !== undefined) {
              if (item.num > this.productMaterialProjectList[item.id]) {
                materialList.push({
                  num: this.productMaterialProjectList[item.id],
                  reduce: item.num - this.productMaterialProjectList[item.id],
                  id: item.id,
                  parentId: obj.id
                })
              } else {
                materialList.push({
                  num: this.productMaterialProjectList[item.id],
                  reduce: 0,
                  id: item.id,
                  parentId: obj.id
                })
              }
            }
          })
        })
      }
      return materialList
    },
    sysCenterId () {
      return this.$store.state.project.product && this.$store.state.project.product.id ? this.$store.state.project.product.sysCenterId : this.$store.state.center.sysCenter.id
    },
    scope () {
      return this.$store.state.project.product && this.$store.state.project.product.id ? 'package' : 'paper'
    },
    receiveOnlineFlag () {
      return this.$store.state.center.sysCenter.receiveOnline
    },
    paymentMethodCodes () {
      return this.$store.state.center.sysCenter.paymentMethodCodes
    },
    actualPrice () {
      let price = this.priceInfo.priceTotal.toString().movePoint(2) + this.vipPrice
      if (this.sysCenterId === '00-77') price = price + this.materialsPrice.toString().movePoint(2)
      //        console.log(price.toString().movePoint(-2) <= 0 ? 0 : price.toString().movePoint(-2))
      return price.toString().movePoint(-2) <= 0 ? 0 : price.toString().movePoint(-2)
    },
    priceTotal () {
      let price = this.priceInfo.priceTotal.toString().movePoint(2) - (this.payment === 'online' ? this.coupon.price : 0).toString().movePoint(2) + this.vipPrice
      if (this.sysCenterId === '00-77') price = price + this.materialsPrice.toString().movePoint(2)
      if (this.medicalCardPrice > price) {
        price = 0
      } else {
        price -= this.medicalCardPrice
      }
      return price.toString().movePoint(-2) <= 0 ? 0 : price.toString().movePoint(-2)
    },
    vipProjectList () {
      let arr = this.initVipProjectList.filter(obj => { return !this.payment || obj.payment === this.payment || obj.payment === 'both' })
      if (!arr.length) {
        this.vipPrice = 0
        this.vipName = ''
      }
      return JSON.parse(JSON.stringify(arr))
    },
    user () {
      return this.$store.state.user && this.$store.state.user.fillUserInfo
    },
    userInfo () {
      return `${this.user.callName} , ${this.user.age}岁 , ${this.sexName} , ${this.marryStateName}`
    },
    unSubmit () {
      return !(this.mobilePhoneValid && this.dateTime !== '请选择体检日期' && this.payment)
    },
    marryStateName () {
      return this.user.marryStateCode === 'unmarried' ? '未婚' : '已婚(含同居)'
    },
    sexName () {
      return this.user.sexCode === 'male' ? '男' : '女'
    },
    deliverValid () {
      return this.deliverConsignee && this.deliverLinkMobile && this.deliverPostAddress && this.deliverCompanyName
    },
    verifyObj () {
      return this.$store.state.center.sysCenter.verify
    },
    hasVerify () {
      let hasVerify = false
      if (this.verifyObj && this.verifyObj.on === '1') {
        hasVerify = !(this.verifyObj.type === '2' && this.scope === 'package' && this.$store.state.project.checkedProjectList.length === 0)
      }
      return hasVerify
    }
  },
  mounted () {
    if (this.hasVerify) {
      this.dataList[2].name = '医生审核'
      this.payment = 'onhospital'
    } else if (this.paymentMethodCodes && this.paymentMethodCodes['online'] && this.priceTotal > 0) {
      this.payment = 'online'
    } else if (this.paymentMethodCodes && this.paymentMethodCodes['onhospital']) {
      this.payment = 'onhospital'
    }
    if (this.sysCenterId === '00-7') {
      this.receiveOnline = this.receiveOnlineList[0]
    }
    this.mobilePhone = (this.$store.state.user && this.$store.state.user.fillUserInfo.code) || this.user.code || this.$store.state.user.self.code || ''
  },
  async created () {
    Loading.show()
    await this.loadTestDate()
    await this.loadCouponData()
    await this.getMedicalCardList()
    let card = this.$store.state.user.medicalCard
    if (this.hasVerify) {
      let newDate = new Date()
      this.nowDate = new Date(newDate.getFullYear() + '-' + (100 + (newDate.getMonth() + 1)).toString().substr(1, 2) + '-' + (100 + newDate.getDate()).toString().substr(1, 2)).getTime()
    }
    if (card && card.cardNo) {
      this.available.forEach(obj => {
        if (obj.cardNo === card.cardNo) {
          obj.select = true
          this.medicalCardList.push(obj)
        }
      })
      this.useMedicalCard()
    }
    if (this.$store.state.quickAppointment) {
      let time = this.$store.state.quickAppointmentTime
      this.dateTime = time.boExaminationDateStr
      this.affirmTime = time.boExaminationTime
      this.showTime = `${this.dateTime} (${this.affirmTime})`
      //
      if (this.sysCenterId === '00-77') {
        this.affirmNo = time.boExaminationTimeNo || ''
        this.arrCode = time.boExaminationTimeNo || ''
      } else { this.affirmNo = time.boExaminationTimeNo || '' }
    }
    if (this.sysCenterId === '00-77') await this.getMaterialsPrice()

    Loading.close()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  @import "@/assets/style/variables.scss";
  .main {
    padding-bottom: 60px;
  }

  .margin-t-10 /deep/ {
    margin-top: 10px;
  }

  .vipM /deep/ {
    .van-actionsheet__content {
      padding: 10px 15px 0 15px;
    }
  }

  .vip-content {
    border: 1px solid $dark09;
    margin: 10px 0;
    padding: 5px;
    line-height: 30px;
    border-radius: 5px;
    text-align: center;
    color: $dark09;
    .vip-price {
      font-weight: 600;
      border-bottom: 1px dashed $dark09;
      position: relative;
      div {
        position: absolute;
        left: 5px;
        /*display: inline-block;*/
      }
    }
    .isShowInspection {
      padding: 0 5px;
      text-align: left;
      /*line-height: 25px;*/
      /*max-height: 75px;*/
      position: relative;
    }
    .isShowInspection button {
      position: absolute;
      right: 0;
      bottom: 2px;
      font-size: 14px;
      height: 22px;
      line-height: 22px;
      padding: 0 10px;
      border: none;
      background: $assertive;
      color: $light;
      /*font-size: 14px;*/
    }
    .isShowInspection pre {
      line-height: 25px;
      max-height: 75px;
      overflow: hidden;
    }
  ;
  }

  .vip-content.active {
    border-color: $assertive;
    color: $assertive;
    .vip-price {
      border-color: $assertive;
    }
  }

  .action-btn-group {
    display: flex;
    justify-content: space-between;
    .action-btn {
      padding: 12px;
      flex: 1;
      margin: 20px;
      text-align: center;
      border: 1px solid #999;
      border-radius: 4px;
      &.assertive {
        border-color: $assertive;
      }
    }
    .dark-btn {
      padding: 8px;
      color: $light !important;
      border: none !important;
      margin: 20px 0;
      background-color: $dark09;
    }
  }

  .m-title {
    width: 100%;
    height: 44px;
    line-height: 44px;
    padding: 0 15px;
    font-size: 14px;
    color: #666666;
    > i {
      display: inline-block;
      width: 3px;
      position: relative;
      top: -1px;
      height: 16px;
      margin-right: 10px;
      background-color: $assertive;
      vertical-align: sub;
    }
  }

  .light-label {
    padding: 0 10px;
    margin-top: 12px;
    height: 24px;
    line-height: 24px;
    font-size: 14px;
    color: #fff;
    background-color: $assertive;
  }

  .icon-radiobox1, .icon-radiobox {
    margin-right: 10px;
    color: #999;
  }

  .m-foot {
    display: flex;
    flex: 1;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #f5f5f5;
    background-color: #ffffff;
    .m-info {
      flex: 1;
      padding-left: 15px;
      .m-info-left {
        font-size: 14px;
        > span {
          font-size: 12px;
          color: $assertive;
          > b {
            font-size: 24px;
          }
        }
      }
    }
    .m-next {
      width: 110px;
      text-align: center;
      font-size: 18px;
      background-color: $assertive;
      color: #ffffff;
      &.disabled {
        background-color: #999;
      }
    }
  }

  .m-item {
    display: flex;
    flex: 1;
    justify-content: space-between;
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding-left: 15px;
    border-bottom: 1px solid #f5f5f5;
    background-color: #ffffff;
    font-size: 16px;
    .item-right {
      position: relative;
      display: inline-flex;
      padding: 0 15px;
      .m-sub {
        font-size: 14px;
        color: #999999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 200px;
      }
      .discounts {
        position: absolute;
        top: -25px;
        right: 40px;
        background: $assertive;
        color: $light;
        height: 25px;
        line-height: 25px;
        display: inline-block;
        /*padding: 0 8px;*/
        width: 130px;
        text-align: center;
        font-size: 13px;
        &:after {
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          border: 10px solid transparent;
          border-right: 3px solid !important;
          border-top-color: $assertive;
          top: 100%;
          left: 80%;
          margin-left: -15px;
        }
      }
      .icon {
        padding-left: 10px;
      }
    }
  }

  .clear-borderBottom {
    border-bottom: none;
    height: 35px;
  }

  .vip /deep/ .m-item .item-right {
    .m-sub {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 230px;
    }
  }

  .m-items {
    display: flex;
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0 15px;
    background-color: #ffffff;
    font-size: 14px;
    border-bottom: 1px solid #f5f5f5;
    > span {
      width: 84px;
      font-size: 16px;
    }
    .m-radios {
      display: inline-flex;
      justify-content: space-between;
      flex: 1;
      padding-right: 15px;
    }
    .m-rads {
      display: inline-flex;
      flex: 1;
      .m-rad {
        padding-right: 35px;
      }
    }
    > em {
      width: 20px;
      text-align: right;
    }
  }

  .notEllipsis /deep/ {
    padding: 5px 0 5px 15px;
    align-items: center;
    height: auto;
    line-height: 1.5;
    .item-right > .m-sub {
      white-space: inherit
    }
  }

  .btn {
    padding: 10px;
    border-radius: 0;
    width: 100%;
    background-color: $assertive;
    border: 1px solid $assertive;
    color: #ffffff;
    &.disabled {
      background-color: #999;
      border-color: #999
    }
  }

  .centerName /deep/ {

    .item-right {
      padding: 10px 5px;
      height: auto;
      line-height: 1.2;
      flex: 0 0 65%;

      align-items: center;
      .m-sub {
        text-align: right;
        /*text-overflow: ellipsis;*/
        /*overflow: hidden;*/
        /*white-space: nowrap;*/
        width: 100%;
      }
    }
  }

  .van-popup /deep/ {
    background-color: #F2F2F2;
    .m-card {

      background-color: $light;
      padding: 10px;
      margin-top: 15px;
      &:first-child {
        margin-top: 0;
      }
      .lineMsg {
        border-top: 1px solid #eeeeee;
        padding: 8px 0 0 0;
        color: $dark09;

      }
      .labels span {
        display: inline-block;
        color: $assertive;
        border: 1px solid $assertive;
        padding: 0 5px;
        border-radius: 5px;
        margin-right: 5px;
      }
    }
    .disabledCard {
      background-color: #CCCCCC;
      .card-item {
        padding: 10px 10px 0 10px;
        background: #CCCCCC !important;
      }
      .lineMsg {
        border-top-color: #CCCCCC;
      }
    }
  }

  .card-item /deep/ {
    padding: 10px 10px 0 10px;
    .item-left {
      img {
        margin-left: 5px;
        width: 70px;
      }
      div {
        /*padding: 0 0 5px 5px ;*/
        /*padding-bottom: 5px;*/
      }
    }
    .item-content {
      line-height: 28px;
      .price {
        font-size: 18px;
        color: $assertive;
      }
    }

    .item-right {
      line-height: 35px;
      text-align: right;
      i.icon {
        font-size: 22px !important;
      }
      /*<!--color: $assertive;-->*/
      span {
        font-size: 20px;
        padding-right: 10px;
      }
      button {
        background: $positive;
        border: none;
        color: $light;
        padding: 0 8px;
        line-height: 28px;
        border-radius: 5px;
      }
      i.icon {
        font-size: 14px;
        position: relative;
        top: -1px;
        color: $assertive;
      }
    }

  }

  .van-popup /deep/{
    .van-tabs__nav {
      background-color: $assertive !important;
    }
    /*.van-tab__pane{*/
    /*padding-bottom: 35px;*/
    /*}*/
  }

  .useCard /deep/ .m-item .item-right .m-sub {
    color: $assertive !important;
  }

  .medicalCardPopup /deep/ {
    height: 100%;
    overflow: hidden;
    .box {
      padding-bottom: 50px;
      position: absolute;
      top: 0;
      bottom: 60px;
      width: 10rem;
      height: 100%;
      overflow-y: auto;
    }
    .isBottom {
      /*background: #F2F2F2;*/
      padding: 5px 15px;
      position: absolute;
      /*top:0;*/
      bottom: 0;
      width: 10rem;
      height: 60px;

    }
    .enableBtn:first-child button {
      background: $dark09;
    }
    .enableBtn {
      margin: 0 !important;
      flex: 0 0 40%;
    }
  }

  .couponList /deep/ {
    height: 100%;
    overflow: hidden;
    > div.isBox {
      padding-bottom: 80px;
      position: absolute;
      top: 0;
      bottom: 0;
      width: 10rem;
      height: 100%;
      overflow-y: auto;

    }
    .enableBtn /deep/ button {
      background: $dark09 !important;
    }
    .isBottom {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
    }
    .certificateItem {
      position: relative;
      img {
        width: 100%;
      }

      .box {

        position: absolute;
        top: 6px;
        bottom: 10px;
        left: 7px;
        right: 7px;
        display: flex;
        .box-left {
          font-size: 15px;
          vertical-align: middle;
          color: $light;
          flex: 0 0 68px;
          text-align: center;
          padding: 30px 20px;
        }
        .disabled-content {
          background: #eeeeee;
        }
        .reason {
          background: #0099FF;
          color: $light;
          font-size: 14px;
          padding: 5px 10px;
          border-radius: 8px;
        }
        .box-content {

          width: 0;
          > div:nth-child(2) {
            padding: 16px 0;
          }
          .time {
            font-size: 14px;
          }
          font-size: 16px;
          padding: 15px 10px 10px 20px;
        }
        .box-right {
          flex: 0 0 90px;
          padding-top: 10px;

          .btnUse {
            background: $dark09;
            color: $light;
            padding: 5px 10px 5px 15px;
            font-size: 14px;
            border-radius: 15px 0 0 15px;
            .icon {
              font-size: 14px;
            }
          }
          .use {
            background: $assertive;
          }
        }
      }

      .icon-danxuankuang {
        font-size: 25px;
      }
      .icon-radiochecked-copy {
        font-size: 25px;
        color: $assertive;
      }

    }
    .btns {

    }
  }
  .warning-info {
    font-size: 16px !important;
    margin-left: 0;
    margin-bottom: 14px;
    line-height: 22px;
    white-space: normal;
    padding: 8px 20px;
    background: $light;
    color: #f2592f;
    position: relative;
    top: -8px;
    z-index: 0;
  }
</style>
